import { useEffect } from 'react'
import { TAB_ID_LS_ID } from '../constants/constants'

export const useChatbotTabManager = (
	tabId: string | undefined,
	callbackFn?: () => void
): React.ReactNode => {
	useEffect(() => {
		const onLocalStorageChange = (event: StorageEvent) => {
			if (
				event.key === TAB_ID_LS_ID &&
				event.oldValue === tabId &&
				event.newValue !== event.oldValue
			) {
				window.removeEventListener('storage', onLocalStorageChange)
				callbackFn?.()
			}
		}

		window.addEventListener('storage', onLocalStorageChange)
	}, [tabId])

	return null
}
